// extracted by mini-css-extract-plugin
export default {"fields":"CreateTeamForm_fields__mqKhm"};